
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const usePsychologistPricing = (psychologistId: string) => {
  return useQuery({
    queryKey: ['psychologist-pricing', psychologistId],
    queryFn: async () => {
      if (!psychologistId) {
        console.warn('⚠️ [WARNING] Sem ID de psicólogo para buscar preços');
        return {
          price_30min: 150,
          price_60min: 280
        };
      }

      console.log('💰 [DEBUG] Buscando preços REAIS para psicólogo:', psychologistId);

      try {
        // Buscar preços específicos do psicólogo na tabela psychologist_pricing
        const { data, error } = await supabase
          .from('psychologist_pricing')
          .select('price_30min, price_60min, currency')
          .eq('psychologist_id', psychologistId)
          .eq('is_active', true)
          .single();

        if (error) {
          console.error('❌ [ERROR] Erro ao buscar preços específicos:', error);
          
          // Fallback: buscar da tabela psychologists
          const { data: psychData, error: psychError } = await supabase
            .from('psychologists')
            .select('price')
            .eq('id', psychologistId)
            .single();
            
          if (psychError) {
            console.error('❌ [ERROR] Erro ao buscar preços da tabela psychologists:', psychError);
            console.warn('⚠️ [WARNING] Usando preços padrão');
            return {
              price_30min: 150,
              price_60min: 280
            };
          }
          
          // Usar preço base para ambas as durações
          const basePrice = psychData.price || 150;
          return {
            price_30min: Math.round(basePrice * 0.75), // 75% do preço de 60min
            price_60min: basePrice
          };
        }

        console.log('💵 [DEBUG] Preços REAIS encontrados:', data);

        const pricingObj = {
          price_30min: data.price_30min || 150,
          price_60min: data.price_60min || 280
        };

        console.log('✅ [SUCCESS] Preços reais carregados:', pricingObj);
        return pricingObj;
        
      } catch (error) {
        console.error('🔥 [FATAL] Erro fatal ao buscar preços reais:', error);
        return {
          price_30min: 150,
          price_60min: 280
        };
      }
    },
    enabled: !!psychologistId,
    staleTime: 1000 * 60 * 5, // Cache por 5 minutos
    retry: 2,
    retryDelay: 1000
  });
};
